/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BusinessObjectFormatDdlRequest { 
    /**
     * The Namespace to which a Business Object Format is related
     */
    namespace: string;
    /**
     * The name of the Business Object Definition to which a Business Object Format is related
     */
    businessObjectDefinitionName: string;
    /**
     * The Usage of this Business Object Format - a string describing how this format is used. Often used as a label for the Business                   Object Format. Does not have to be unique in the system, the Usage string is frequently shared across formats for multiple Business Object                   Definitions                
     */
    businessObjectFormatUsage: string;
    /**
     * A File Type known to the system that describes the file type of data stored under a Business Object Format
     */
    businessObjectFormatFileType: string;
    /**
     * The numeric version of a Business Object Format. If not supplied, the latest version will be used
     */
    businessObjectFormatVersion?: number;
    /**
     * The output format for the generated DDL. The only format currently supported is HIVE_13_DDL
     */
    outputFormat: BusinessObjectFormatDdlRequest.OutputFormatEnum;
    /**
     * The table name to be used in the generated DDL
     */
    tableName: string;
    /**
     * The name of the Custom DDL. When Custom DDL name is specified, the Custom DDL which had previously been stored Business Object                   Format is returned instead of generated DDL. Must not be specified when replaceColumns is true                
     */
    customDdlName?: string;
    /**
     * If true, drop table statement for existing table will be added to the generated DDL. Must not be specified when replaceColumns                   is true.                
     */
    includeDropTableStatement?: boolean;
    /**
     * If true, IF NOT EXISTS option will be added to the CREATE TABLE ... statement in the generrated DDL. Please note that this                   parameter value has no effect on the relative CREATE TABLE ... statement, if generated DDL uses custom DDL. Must not be specified when                   replaceColumns is true.                
     */
    includeIfNotExistsOption?: boolean;
    /**
     * If true, an ALTER TABLE ... REPLACE COLUMNS will be generated
     */
    replaceColumns?: boolean;
}
export namespace BusinessObjectFormatDdlRequest {
    export type OutputFormatEnum = 'HIVE_13_DDL';
    export const OutputFormatEnum = {
        HIVE13DDL: 'HIVE_13_DDL' as OutputFormatEnum
    };
}
